module.exports = __webpack_public_path__ + "static/Corprate_WhoWeAre_04-180e12b4755d36cdccec823a50a1777c.jpg";